import { ComponentType } from "react";

interface BreadcrumbsRegistryEntry {
  component: ComponentType;
  isActive: (pathname: string) => boolean;
}

const breadcrumbsRegistry: BreadcrumbsRegistryEntry[] = [];

export const registerBreadcrumbs = (entry: BreadcrumbsRegistryEntry) => {
  breadcrumbsRegistry.push(entry);
};

export const getBreadcrumbsComponent = (
  pathname: string,
): ComponentType | null => {
  const entry = breadcrumbsRegistry.find((e) => e.isActive(pathname));
  return entry?.component ?? null;
};

export const resetBreadcrumbsRegistry = () => {
  breadcrumbsRegistry.length = 0;
};
